import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './spec.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Spec } from "model/product/spec.model";

export interface SpecDetailsProps extends DetailsStateAndDispatchProps<Spec>,
  RouteComponentProps, StateProps, DispatchProps {
}
const SpecDetails: FC<SpecDetailsProps> = (props) => {
  return (
    <DetailsPage<Spec>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Spec>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ spec }: RootState) => ({
  entity: spec.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SpecDetails);
